import { Helmet } from 'react-helmet-async';
import { Card, Container, Grid, Tab, Table, TableBody, TableCell, TableHead, TableRow, Tabs, } from '@mui/material';
import type { SyntheticEvent } from "react";
import { useEffect, useState } from "react";
import 'react-calendar-heatmap/dist/styles.css';
import type { TagAccuracy } from "../api/inside-service";
import { InsideService } from "../api/inside-service";

import ENV from "../env";
import PageHeader from "../components/text/PageHeader";
import './InsidePage.css'

type InsideTopic = {
    title: string;
    id: string;
};

const topics: InsideTopic[] = [
    { title: 'Java', id: 'java' },
    { title: 'AWS', id: 'aws' },
    { title: 'Spring', id: 'spring' },
    { title: 'Kafka', id: 'kafka' },
    { title: 'Linux', id: 'linux' },
    { title: 'Docker & K8s', id: 'docker' },
    { title: 'MongoDB', id: 'mongodb' },
    { title: 'React', id: 'react' },
    { title: 'Angular', id: 'angular' },
    { title: 'TypeScript', id: 'typescript' }
    // {title: 'Python', id: 'python'},
    // {title: 'SQL', id: 'SQL'},
].sort((a, b) => (a.title > b.title) ? 1 : -1);

/** Columns are keyed by the numeric fields of TagAccuracy plus the tag itself. */
type TagColumn = {
    title: string;
    id: keyof TagAccuracy;
    postfix?: string;
};

const tagColumns: TagColumn[] = [
    { title: 'Tag', id: 'tag' },
    { title: 'Answers', id: 'answers' },
    { title: 'Rate of correct', id: 'rate', postfix: '%' },
    { title: 'Rate of skipped', id: 'skippedRate', postfix: '%' },
];

export default function InsidePage() {
    const [ selectedTopicId, setSelectedTopicId ] = useState(topics[0].id);
    const [ selectedTopic, setSelectedTopic ] = useState<InsideTopic>(topics[0]);
    const [ tags, setTags ] = useState<TagAccuracy[]>([]);

    useEffect(() => {
        const topic = topics.find(topic => topic.id === selectedTopicId);
        if (topic) setSelectedTopic(topic);

        setTags([]);

        InsideService.tagsRate(selectedTopicId).then((response) => {
            console.log('Tags rate', response);
            setTags(response);
        });
    }, [ selectedTopicId ]);

    function selectTopic(event: SyntheticEvent, newValue: string) {
        setSelectedTopicId(newValue);
    }

    return <>
        <Helmet>
            <title>Inside | { ENV.APP_NAME }</title>
        </Helmet>

        <Container>
            <PageHeader title="Tags Knowledge" sx={ { mt: '30px' } }/>

            <Card>
                <Grid container sx={ { width: '100%' } }>
                    { /* The original passed s="12" m="4" here: not MUI Grid props, so they never
                         affected layout. Dropped rather than translated to item/xs/md, which
                         would have changed how this page renders. */ }
                    <Grid>
                        <Tabs value={ selectedTopicId } orientation="vertical" onChange={ selectTopic }>
                            { topics.map(topic => <Tab key={ topic.id } label={ topic.title } value={ topic.id }/>) }
                        </Tabs>
                    </Grid>

                    <Grid sx={ { px: '25px', py: '15px' } }>
                        <PageHeader title={ `${ selectedTopic.title } Learning` }/>

                        { tags && (
                            <Table sx={ { minWidth: 450 } }>
                                <TableHead>
                                    <TableRow>
                                        { tagColumns.map(column => <TableCell
                                            key={ column.id }>{ column.title }</TableCell>) }
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    { tags.map(record =>
                                        <TableRow key={ `${ selectedTopicId }-${ record.tag }` }>
                                            { tagColumns.map(column =>
                                                <TableCell
                                                    key={ `${ selectedTopicId }-${ column.id }-${ record.tag }` }>
                                                    { record[column.id] }{ column.postfix }
                                                </TableCell>
                                            ) }
                                        </TableRow>
                                    ) }
                                </TableBody>
                            </Table>
                        ) }
                    </Grid>
                </Grid>
            </Card>
        </Container>
    </>;
}
